import { matchPath } from 'react-router-dom';

export const publicRoutes = [
  '/login',
  '/activate',
  // IAM's activation link once OIDC is enabled: `<app>/oidc/activate/<tenantId>?code=...`.
  '/oidc/activate/:tenantId',
  '/success',
  '/activate-failed',
  '/login/oidc',
];

/** Whether `pathname` is a public (signed-out) route; entries may hold `:param` segments. */
export const isPublicRoute = (pathname: string) =>
  publicRoutes.some((route) => matchPath(route, pathname));
